import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { RoleService } from '../../../services/role.service';
import { Role } from '../../../models/role';
import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-team-role-dialog',
  templateUrl: './team-role-dialog.component.html',
  styleUrls: ['./team-role-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class TeamRoleDialogComponent implements OnInit {

  //public Editor = ClassicEditor;
  public local_title: string;
  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;


  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _roleService: RoleService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: Role
  ) { }


  ngOnInit() {

    this._adapter.setLocale('pt');

console.log("this.data.id: " + this.data.id)

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
      this.local_title = "Papel: " + this.data.name
    } else {
      this.isEdit = false
      this.local_title = "Novo Papel"
    }
    
    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)    
  }

  insert() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Role = this.createEntity(this.entityForm.value);

      this._roleService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert role error: " + error)
          let msgError: string = this._roleService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Role = this.createEntity(this.entityForm.value);

      this._roleService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("role update error: " + JSON.stringify(error))
          let msgError: string = this._roleService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity(data: any): Role {
    let entity = new Role();
    entity.id = data.id;
    entity.name = data.name;
    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
    });
    return form
  }


}